var _circle, _circle2, _circle3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSetupComplete = function SvgSetupComplete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 52,
    cy: 52,
    r: 51.5,
    stroke: "#69D4A1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 52,
    cy: 52,
    r: 43.5,
    stroke: "#69D4A1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 36,
    fill: "#EBF9F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 41.2309V51.3829C39.0001 54.5918 39.9725 57.7253 41.7891 60.3705C43.6056 63.0156 46.1811 65.0482 49.176 66.2003L50.564 66.7336C51.4884 67.0891 52.5117 67.0891 53.436 66.7336L54.824 66.2003C57.819 65.0482 60.3944 63.0156 62.211 60.3705C64.0276 57.7253 65 54.5918 65 51.3829V41.2309C65.0026 40.8489 64.8947 40.4743 64.6894 40.1521C64.4841 39.8299 64.1901 39.574 63.8427 39.4149C60.1092 37.7853 56.0736 36.9625 52 37.0003C47.9265 36.9625 43.8909 37.7853 40.1574 39.4149C39.81 39.574 39.516 39.8299 39.3107 40.1521C39.1054 40.4743 38.9975 40.8489 39 41.2309V41.2309Z",
    stroke: "#69D4A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0594 53.2336C50.1293 53.1636 50.2184 53.1159 50.3154 53.0966C50.4124 53.0772 50.5129 53.0871 50.6043 53.1249C50.6957 53.1627 50.7739 53.2268 50.8288 53.3091C50.8838 53.3913 50.9131 53.488 50.9131 53.5869C50.9131 53.6858 50.8838 53.7825 50.8288 53.8648C50.7739 53.947 50.6957 54.0111 50.6043 54.0489C50.5129 54.0867 50.4124 54.0966 50.3154 54.0773C50.2184 54.0579 50.1293 54.0102 50.0594 53.9402C50.0129 53.8939 49.9759 53.8389 49.9508 53.7782C49.9256 53.7176 49.9126 53.6526 49.9126 53.5869C49.9126 53.5213 49.9256 53.4562 49.9508 53.3956C49.9759 53.335 50.0129 53.2799 50.0594 53.2336Z",
    stroke: "#69D4A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.449 51.6133L60.365 46.6959C60.5663 46.4946 60.7261 46.2555 60.835 45.9924C60.944 45.7293 61.0001 45.4474 61.0001 45.1626C61.0001 44.8778 60.944 44.5959 60.835 44.3328C60.7261 44.0697 60.5663 43.8306 60.365 43.6293C60.1636 43.4279 59.9246 43.2682 59.6615 43.1592C59.3984 43.0502 59.1164 42.9941 58.8316 42.9941C58.5469 42.9941 58.2649 43.0502 58.0018 43.1592C57.7387 43.2682 57.4997 43.4279 57.2983 43.6293L52.3863 48.5506C51.2285 48.0972 49.95 48.0562 48.7656 48.4344C47.5811 48.8127 46.563 49.5871 45.8823 50.6276C45.2016 51.6681 44.8999 52.9112 45.0277 54.148C45.1556 55.3848 45.7054 56.5398 46.5846 57.419C47.4638 58.2982 48.6188 58.8479 49.8556 58.9758C51.0924 59.1037 52.3355 58.802 53.3759 58.1213C54.4164 57.4406 55.1909 56.4224 55.5691 55.238C55.9474 54.0536 55.9064 52.775 55.453 51.6173L55.449 51.6133Z",
    stroke: "#69D4A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSetupComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "setup-complete.f9656b0f6440698c970579a3933821a0.svg";